// Entity type constants
export const PORTFOLIO = "portfolio" as const;
export const ACCOUNT = "account" as const;

export const ENTITY_TYPES = {
    PORTFOLIO,
    ACCOUNT,
} as const;

export type EntityType = typeof PORTFOLIO | typeof ACCOUNT;
